// AdSense settings for the public site.
// Each placement has its own key so it can get its own ad unit in AdSense
// (Ads > By ad unit > Display ads) and be tracked separately in reports.
// Until dedicated units exist they all share the responsive display unit.
export const ADSENSE_CLIENT = "ca-pub-5486214968700891";

const DEFAULT_SLOT = "3633561207";

export const AD_SLOTS = {
    songTop: DEFAULT_SLOT,
    songBottom: DEFAULT_SLOT,
    songSidebar: DEFAULT_SLOT,
    homeFeed: DEFAULT_SLOT,
    listFeed: DEFAULT_SLOT,
    article: DEFAULT_SLOT,
};
